import { defineMessages } from "react-intl";

const PREFIX = "DepartmentBlockPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Department's list",
  },
  addUserFormHeader: {
    id: `${PREFIX}.addUserFormHeader`,
    defaultMessage: "Add department form",
  },
  editUserFormHeader: {
    id: `${PREFIX}.editUserFormHeader`,
    defaultMessage: "Edit department form",
  },
  saveButton: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancelButton: {
    id: `${PREFIX}.cancelButton`,
    defaultMessage: "Cancel",
  },
  addUserButton: {
    id: `${PREFIX}.addUserButton`,
    defaultMessage: "Add new department",
  },
  editButton: {
    id: `${PREFIX}.editButton`,
    defaultMessage: "Edit",
  },
  deleteButton: {
    id: `${PREFIX}.deleteButton`,
    defaultMessage: "Delete",
  },
  login: {
    id: `${PREFIX}.login`,
    defaultMessage: "Login",
  },
  name: {
    id: `${PREFIX}.name`,
    defaultMessage: "Name",
  },
  surname: {
    id: `${PREFIX}.surname`,
    defaultMessage: "Surname",
  },
  department: {
    id: `${PREFIX}.department`,
    defaultMessage: "Department",
  },
  fieldIsRequired: {
    id: `${PREFIX}.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  checkCorrectness: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  confirmDialogContent: {
    id: `${PREFIX}.dialog.content`,
    defaultMessage: `Are you sure to delete {name} {surname}?`,
  },
  confirmDialogBtnYes: {
    id: `${PREFIX}.dialog.btn.yes`,
    defaultMessage: "Yes",
  },
  confirmDialogBtnNo: {
    id: `${PREFIX}.dialog.btn.no`,
    defaultMessage: "No",
  },
  responseErrorAdminDuplicateEmail: {
    id: `${PREFIX}.response.error.admin.duplicate.email`,
    defaultMessage: "The e-mail is already registered",
  },
  emailNotInSystem: {
    id: `${PREFIX}.error.emailNotInSystem`,
    defaultMessage: "Sorry, this email can not be registered in the system.",
  },
});
